export const createScheduledEventMetadataWithConnection = /* GraphQL */ `
  mutation CreateScheduledEventMetadata(
    $input: CreateScheduledEventMetadataInput!
    $condition: ModelScheduledEventMetadataConditionInput
  ) {
    createScheduledEventMetadata(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      job {
        id
        tenant
        landscape
        tenantLandscape
        jobCode
        title
        description
        jobTriggerFilePath
        tasks {
          nextToken
        }
        hasOutputFile
        createdAt
        updatedAt
      }
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
    }
  }
`;

export const deleteScheduledEventMetadataWithConnection = /* GraphQL */ `
  mutation DeleteScheduledEventMetadata(
    $input: DeleteScheduledEventMetadataInput!
    $condition: ModelScheduledEventMetadataConditionInput
  ) {
    deleteScheduledEventMetadata(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      job {
        id
        tenant
        landscape
        tenantLandscape
        jobCode
        title
        description
        jobTriggerFilePath
        tasks {
          nextToken
        }
        hasOutputFile
        createdAt
        updatedAt
      }
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
    }
  }
`;

export const updateScheduledEventMetadataWithConnection = /* GraphQL */ `
  mutation UpdateScheduledEventMetadata(
    $input: UpdateScheduledEventMetadataInput!
    $condition: ModelScheduledEventMetadataConditionInput
  ) {
    updateScheduledEventMetadata(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      job {
        id
        tenant
        landscape
        tenantLandscape
        jobCode
        title
        description
        jobTriggerFilePath
        tasks {
          nextToken
        }
        hasOutputFile
        createdAt
        updatedAt
      }
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
    }
  }
`;
